import { useEffect } from 'react';
import { isSignUpOrganizationEnabled } from 'common/validators';
import { usePublicOrganizationsInfiniteQuery } from 'features/organizations';
import { type PrimaryOrganizationOption, useCreatePrimaryOrganizationOption } from '../primary-organization-select';

type P = {
  communityId?: string;
  onPrimaryOrganization: (organization: PrimaryOrganizationOption) => void;
};

export const usePreselectPrimaryOrganization = ({ communityId, onPrimaryOrganization }: P) => {
  const createPrimaryOrganizationOption = useCreatePrimaryOrganizationOption();
  const isEnabled = Boolean(communityId) && isSignUpOrganizationEnabled();

  const { data, isFetching, isLoading } = usePublicOrganizationsInfiniteQuery({
    filter: { communityId },
    options: { enabled: isEnabled },
    pagination: { pageSize: 10 },
  });

  useEffect(() => {
    const organizations = data?.pages.flatMap((organizationsPaginated) => organizationsPaginated.data);
    const organization = organizations ? organizations[0] : undefined;

    if (isEnabled && organization) {
      onPrimaryOrganization(createPrimaryOrganizationOption(organization));
    }
  }, [onPrimaryOrganization, createPrimaryOrganizationOption, isEnabled, data]);

  return { isLoading: isEnabled && isLoading && isFetching };
};
